import { useCallback, useEffect, useState } from "react";
import api, { fmtDateTime, fmtErr } from "../../lib/api";
import { toast } from "sonner";

const inputCls = "w-full rounded-xl border border-slate-200 px-4 py-2.5 text-sm focus:border-shipany-blue focus:outline-none";

export default function AdminSupport() {
  const [tickets, setTickets] = useState(null);
  const [reply, setReply] = useState({});

  const load = useCallback(() => api.get("/admin/support").then(({ data }) => setTickets(data)).catch(() => {}), []);
  useEffect(() => { load(); }, [load]);

  const act = async (t, payload) => {
    try {
      await api.put(`/admin/support/${t.ticket_id}`, payload);
      toast.success("Ticket updated");
      setReply({ ...reply, [t.ticket_id]: "" });
      load();
    } catch (e) { toast.error(fmtErr(e)); }
  };

  return (
    <div data-testid="admin-support-page">
      <h1 className="font-display text-2xl font-bold tracking-tight text-shipany-navy">Support Tickets</h1>
      <p className="text-sm text-slate-500">{tickets?.length ?? 0} tickets from customers.</p>
      <div className="mt-6 space-y-4">
        {(tickets || []).map((t) => (
          <div key={t.ticket_id} className="rounded-2xl border border-slate-200 bg-white p-5" data-testid={`admin-ticket-${t.ticket_id}`}>
            <div className="flex flex-wrap items-center justify-between gap-2">
              <div>
                <h3 className="font-semibold text-shipany-navy">{t.subject}</h3>
                <p className="text-xs text-slate-400">{t.email} · {fmtDateTime(t.created_at)} · {t.priority}</p>
              </div>
              <select value={t.status} onChange={(e) => act(t, { status: e.target.value })} data-testid={`ticket-status-${t.ticket_id}`}
                className="rounded-lg border border-slate-200 px-3 py-1.5 text-xs font-bold focus:border-shipany-blue focus:outline-none">
                {["open", "in_progress", "resolved", "closed"].map((s) => <option key={s}>{s}</option>)}
              </select>
            </div>
            <p className="mt-2 text-sm text-slate-500">{t.message}</p>
            {(t.replies || []).map((r, i) => (
              <div key={i} className="mt-2 rounded-lg bg-shipany-mist px-4 py-2 text-sm"><span className="font-semibold text-shipany-blue">Support:</span> {r.message}</div>
            ))}
            <div className="mt-3 flex gap-2">
              <input className={inputCls} placeholder="Write a reply…" value={reply[t.ticket_id] || ""} onChange={(e) => setReply({ ...reply, [t.ticket_id]: e.target.value })} data-testid={`ticket-reply-${t.ticket_id}`} />
              <button onClick={() => reply[t.ticket_id]?.trim() && act(t, { reply: reply[t.ticket_id] })} data-testid={`ticket-reply-btn-${t.ticket_id}`}
                className="rounded-xl bg-shipany-blue px-5 text-sm font-bold text-white hover:bg-[#0648B3]">Reply</button>
            </div>
          </div>
        ))}
        {tickets && tickets.length === 0 && <div className="rounded-2xl border border-dashed border-slate-300 bg-white p-12 text-center text-sm text-slate-400">No tickets yet.</div>}
      </div>
    </div>
  );
}
